var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "deactivate-2fa",
    attrs: { visible: _vm.showModal, size: "small", title: _vm.getTitle },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _vm.provider
                  ? [
                      _c("ProviderLabel2FA", {
                        attrs: { provider: _vm.provider }
                      }),
                      _vm._v(" "),
                      _vm.provider.primary
                        ? [
                            _c("p", { staticClass: "semibold m-0 mb-2" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "En désactivant votre méthode d'authentification principale, vous ne recevrez plus de code de sécurité sur celle-ci."
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "m-0 mb-3" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Si vous n'avez pas défini de méthode d'authentification secondaire, la double authentification sera désactivée sur votre compte."
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.requiredFromCorp
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "alert alert-danger m-0 flex-row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "no-shrink mr-2" },
                                      [
                                        _c("CompassIcon", {
                                          attrs: {
                                            type: "alert",
                                            icon: "alert-circle-fill"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("p", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "La double authentification a été rendue obligatoire par l'administrateur de votre société."
                                              )
                                            ) +
                                            "\n                            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "En continuant, vous allez être déconnecté de votre compte. Reconnectez-vous pour configurer la double authentification avec une nouvelle méthode d'authentification."
                                              )
                                            ) +
                                            "\n                            "
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        : [
                            _c("p", { staticClass: "semibold m-0 mb-2" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "En désactivant votre méthode d'authentification secondaire, vous ne recevrez plus de code de sécurité sur celle-ci."
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "m-0 mb-3" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "La sécurité de votre compte reste renforcée. Vous recevrez les codes de sécurité sur votre méthode d'authentification principale."
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ]
                    ]
                  : [
                      _c("p", { staticClass: "semibold m-0 mb-2" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__(
                                "En désactivant la double authentification, la sécurité de votre compte ne sera plus renforcée."
                              )
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-0 mb-3" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Vous ne recevrez plus aucun code de sécurité si nous remarquons une tentative de connexion depuis un appareil non reconnu."
                              )
                            ) +
                            "\n                "
                        )
                      ])
                    ]
              ],
              2
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: { click: _vm.close }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.provider
                      ? _vm.$t.__("common.actions.disable")
                      : _vm.$t.__(
                          "popups.Deactivate2FA.disable_dual_authentication"
                        ),
                    type: _vm.isSecondary ? "primary" : "primary-destructive",
                    loading: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }